module.exports = __webpack_public_path__ + "5b66cc82ae71cbe99fa3920e92fd76dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/picture.png
// module id = 222
// module chunks = 0